<template>
	<TransitionRoot as="template" :show="open">
		<Dialog as="div" static class="fixed z-20 inset-0 overflow-hidden" @close="$emit('close')" :open="open">
			<div class="absolute inset-0 overflow-hidden">
				<TransitionChild as="template" enter="ease-in-out duration-500" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-500" leave-from="opacity-100" leave-to="opacity-0">
					<DialogOverlay class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
				</TransitionChild>

				<div class="fixed inset-y-0 right-0 pl-2 sm:pl-10 max-w-full flex">
					<TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">						
						<div class="w-screen max-w-2xl">
							<div class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">
								<div class="min-h-0 flex-1 flex flex-col py-6 overflow-y-scroll">
									<div class="px-4 sm:px-6">
										<div class="flex items-start justify-between">
											<DialogTitle class="text-lg font-medium text-gray-900">
												{{ __('home::orders.stock_photos') }}
											</DialogTitle>
											<div class="ml-3 h-7 flex items-center">
												<button class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" @click="$emit('close')">
													<span class="sr-only">Close panel</span>
													<XIcon class="h-6 w-6" aria-hidden="true" />
												</button>
											</div>
										</div>
									</div>
									<div class="mt-6 relative flex-1 px-4 sm:px-6">
										
										<div v-if="loading">
											<svg class="mx-auto mt-12 h-12 w-12 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
												<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
												<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
											</svg>
										</div>

										<div v-else>

											<button
												type="button"
												class="px-4 py-2 mr-1 mb-2 inline-block rounded-md text-white"
												:class="{ 
													'bg-gray-700' : category !== k ,
													'bg-black' : category === k ,
												}"
												v-for="(v, k) in categories"
												:key="k"
												@click="category = k"
											>
												{{ v }}
											</button>

											<div class="mt-6 grid grid-cols-3 gap-4">

												<div
													v-for="stockPhoto in stockPhotosInCategory"
													:key="stockPhoto.id"
													class="h-36 bg-gray-50 bg-cover bg-center bg-no-repeat relative"
													:style="{ backgroundImage: 'url(' + stockPhoto.public_thumb_path + ')' }"
													@click="select(stockPhoto.id)"
												>
													<div v-if="selected.includes(stockPhoto.id)">
														<div class="absolute top-0 right-0 w-full h-full bg-white opacity-50"></div>
														<div class="relative h-36 z-10 flex items-center justify-center">
															<CheckIcon class="h-10 w-10 text-black" />
														</div>
													</div>
												</div>

											</div>

										</div>
										
									</div>
								</div>
								<div class="flex-shrink-0 px-4 py-4 flex justify-end">
									<button type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="$emit('close')">
										{{ __('forms::actions.cancel') }}
									</button>
									<button 
										type="button" 
										class="ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none" 
										:class="{ 
											'bg-indigo-300': selected.length == 0,
											'bg-indigo-600 hover:bg-indigo-700': selected.length > 0,
										}"
										:disabled="selected.length == 0"
										@click="addStockPhotos()"
									>
										{{ __('forms::actions.add_photos') }} 
										<span v-if="selected.length > 0" class="inline-block pl-1">({{ selected.length }})</span>
									</button>
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>

<script>
	import axios from 'axios'

	import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
	import { CheckIcon, XIcon } from '@heroicons/vue/outline'

	export default {
		components: {
			Dialog,
			DialogOverlay,
			DialogTitle,
			TransitionChild,
			TransitionRoot,
			CheckIcon,
			XIcon,
		},
		props: {
			open: {
				type: Boolean,
				default: false,
			},
			order: {
				type: Object,
			},
			product: {
				type: Object,
			},
		},
		data() {
			return {
				initiated: false,
				loading: true,
				categories: {},
				stockPhotos: {},
				category: 'quotes',
				selected: [],
			}
		},
		computed: {
			stockPhotosInCategory() {
				return this.stockPhotos.filter(x => x.category === this.category);
			},
		},
		watch: {
			open: function(newVal, oldVal) {
				if (! this.initiated && newVal === true) {
					this.loadStockPhotos();
				}
			},
		},
		methods: {
			loadStockPhotos() {
				axios
                    .get(this.$route('home::stock-photos.index'))
                    .then((res) => {
                        this.loading = false;
                        this.categories = res.data.categories;
                        this.stockPhotos = res.data.stockPhotos;
                    });
			},
			select(id) {
				if (this.selected.includes(id)) {
					var index = this.selected.indexOf(id);
					this.selected.splice(index, 1);
				}
				else {
					this.selected.push(id);
				}
			},
			addStockPhotos() {
				if (this.selected.length == 0) {
					return;
				}

				var request = {
					stock_photos: this.selected,
				};

				if (this.product) {
					request.product_id = this.product.id;
				}

				axios
                    .post(this.$route('home::orders.photos.add-stock', { uuid: this.order.uuid }), request)
                    .then((res) => {
                        this.$emit('append-photos', res.data);
                        this.$emit('close');
                    });
			},
		},
	}
</script>